<template>
  <div
    v-if="modelValue"
    class="modal-overlay"
    @click.self="close"
  >
    <div class="modal">
      <button class="modal__close-button" @click="close">
        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="53" height="53" rx="26.5" fill="white"/>
          <rect x="0.5" y="0.5" width="53" height="53" rx="26.5" stroke="#121318"/>
          <path d="M33 32.75L21 20.75" stroke="#121318" stroke-width="2"/>
          <path d="M21 32.75L33 20.75" stroke="#121318" stroke-width="2"/>
        </svg>

      </button>
      <span class="modal__title">
        <slot name="title">{{ title }}</slot>
      </span>
      <div class="modal__content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'

defineProps({
  modelValue: { type: Boolean, required: true },
  title: { type: String, default: '' },
})

const emit = defineEmits(['update:modelValue'])

function close() {
  emit('update:modelValue', false)
}
</script>

<style scoped lang="scss">
@import '@boats/ui/styles/config';

.modal {
  position: relative;
  background: $white;
  padding: 32px 20px 32px 28px;
  border-radius: 8px;
  width: 90%;
  height: 90vh;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);

  @include media-breakpoint-up(lg) {
    width: 620px;
  }

  &-overlay.active {
    display: flex;
  }

  &-overlay {
    display: flex;
    position: fixed;
    top: 0; left: 0;
    width: 100%; height: 100%;
    background: rgba(0,0,0,0.6);
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  &__close-button {
    @include no-bg-button;
    position: absolute;
    padding: 0;
    width: 36px;
    height: 36px;
    top: 20px;
    right: 20px;

    & > svg {
      width: 36px;
      height: 36px;
    }

    @include media-breakpoint-up(lg) {
      width: 54px;
      height: 54px;
      right: -27px;
      top: -27px;
    }

    &:hover {
      & > svg {
        @include smooth-transition;
        fill: $black;

        & path {
          stroke: $white;
        }
      }
    }
  }

  &__title {
    @include h3-poppins;
    display: block;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 1px solid $gray-200;

    @include media-breakpoint-up(lg) {
      padding-bottom: 0;
      border-bottom: none;
    }
  }

  &__tabs {
    display: none;
    justify-content: space-between;
    margin-bottom: 28px;
    border-top: 1px solid $gray-200;
    border-bottom: 1px solid $gray-200;

    @include media-breakpoint-up(lg) {
      display: flex;
    }
  }

  &__tab {
    @include label-button;
    padding: 24px 26px 15px 26px;
    display: inline-block;
    cursor: pointer;

    &.active {
      font-weight: bold;
      border-bottom: 4px solid $black;
    }
  }

  &__content {
    height: 73%;
    overflow-y: auto;

    :deep(ul) {
      padding-left: revert;
      list-style-type: revert;
    }

    & h3 {
      @include label-large;
    }
  }
}
</style>
